import { compact } from 'lodash';
import { createSelector } from 'reselect';

import { FeatureFlagHelpers } from '../common/feature-flag-helpers';
import { AppStateFeatures } from '@mode/legacy/types-app-state';
import { OrganizationFeatures, ReportResourceHelper } from '@mode/shared/util-halogen';
import { AppState } from '@mode/legacy/types-app-state';
import { fromReportViewerSelectors } from '@mode/report-viewer/domain';
import { ActiveExplorationSelectors } from './active-exploration.selectors';
import { OrgTypes } from '@mode/shared/contract-common';

export namespace FeatureSelectors {
  export const getReportContextFeatures = (state: AppState) => state.client.reportContextFeatures;
  export const getAccountContextFeatures = (state: AppState) => state.client.accountContextFeatures;
  export const getReportContext = (state: AppState) => state.client.reportContext;
  export const getAccountContext = (state: AppState) => state.client.accountContext;
  export const getSelectedReportResource = (state: AppState) => state.client.selectedReport.report;

  export const getOrgFeatureFlags = createSelector(
    getReportContextFeatures,
    getAccountContextFeatures,
    (reportOrgFeatures, accountOrgFeatures) => [
      ...FeatureFlagHelpers.orgFeaturesToFeatureFlags(reportOrgFeatures, OrganizationFeatures.Context.Report),
      ...FeatureFlagHelpers.orgFeaturesToFeatureFlags(accountOrgFeatures, OrganizationFeatures.Context.User),
    ]
  );

  export const getOrgPlanFeatureFlag = createSelector(getReportContext, getAccountContext, (reportOrg, accountOrg) =>
    compact([
      FeatureFlagHelpers.orgPlanCodeToFeatureFlag(reportOrg, OrgTypes.PlanCodeContext.Report),
      FeatureFlagHelpers.orgPlanCodeToFeatureFlag(accountOrg, OrgTypes.PlanCodeContext.User),
    ])
  );

  export const getAppStateFeatureFlag = createSelector(
    getSelectedReportResource,
    fromReportViewerSelectors.getDrilldownsEnabled,
    ActiveExplorationSelectors.getGfDrilldownEnabled,
    (report, reportDrilldownsEnabled, explorationDrilldownEnabled) => {
      const drilldownsEnabled =
        report !== null
          ? ReportResourceHelper.canDrilldown(report)
          : reportDrilldownsEnabled || explorationDrilldownEnabled;

      return FeatureFlagHelpers.appStatesToFeatureFlags({
        [AppStateFeatures.Type.SelectedReport.DrillDownsEnabled]: drilldownsEnabled,
      });
    }
  );

  export const getEnabledFeatures = createSelector(
    getOrgFeatureFlags,
    getOrgPlanFeatureFlag,
    getAppStateFeatureFlag,
    (toggles, plan, app) => [...toggles, ...plan, ...app]
  );
}
